import React from 'react'
import { ReactSVG } from 'react-svg';

import '../styles/header.css';
import Info from '../assets/icons/info-circle-solid.svg';
import ReactIcon from '../assets/icons/undraw_react_y7wq.svg';

const Header = () => {

    return (
        <div className="header">
            <div className="navbar">
                <button>Greet Me</button> 
                {/* <ReactSVG
                    src={Info}
                    beforeInjection={(svg) => {
                        svg.style.width = '40px';
                        svg.style.height = '40px';
                    }}
                    wrapper="span"
                    className="info-svg"
                /> */}
            </div>

            <div className="info">
                <ReactSVG
                    src={ReactIcon}
                    beforeInjection={(svg) => {
                        svg.style.width = '200px';
                        svg.style.height = '100px';
                    }}
                    wrapper="span"
                />

                <h1>Front End, React Developer</h1>

                <p>I'm a fan of <strong>SIMPLISTIC</strong> and <strong>MINIMALISTIC</strong></p>
            </div>
        </div>
    )
}

export default Header
